import PropTypes from "prop-types";

// Layouts
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		ranges = {
			min: 0,
			max: 1000000,
		},
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	const inputData = {
		type: "Unit",
		min: ranges?.min || 0,
		max: ranges?.max || 1000000,
		decimalsEditable: true,
		decimals: 2,
	};

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							...inputData,
							dashed: fromDisabled,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Unit",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							...inputData,
							dashed: toDisabled,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Unit",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	ranges: PropTypes.object,
	errors: PropTypes.array,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
